import { render, staticRenderFns } from "./WholesalerStatement.vue?vue&type=template&id=17170dde"
import script from "./WholesalerStatement.vue?vue&type=script&lang=js"
export * from "./WholesalerStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports